// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"838095c8cc049b4bbe57","453":"45653e92d30b38a4c491"}[chunkId] + ".js";
};